import { defineMessages } from "react-intl";

const messages = defineMessages({
    newVersion: {
        id: "notification.newVersion",
    },
});

export default messages;
